<template>
  <ul
    v-show="show"
    ref="TheList"
    class="absolute z-filterList min-w-40 max-h-3/5 overflow-auto bg-white border shadow"
  >
    <li v-if="list.length === 0" class="p-4 cursor-not-allowed">No matches</li>
    <li
      v-for="(item, i) in list"
      v-else
      :key="item._id"
      class="p-2 border-b last:border-b-0 cursor-pointer"
      :class="{'bg-gray-300': i === keyNavigationIndex}"
      @mousedown="selectOne(item)"
      @touchend="selectOne(item)"
      @mouseover="keyNavigationIndex = i"
    >
      <user-info
        v-if="type === 'USER_MENTION'"
        :user="item"
        :label="item.username"
        size="28px"
      />
      <!-- default fallback -->
      <span v-else>{{ item.label }} </span>
    </li>
  </ul>
</template>

<script>
import UserInfo from '@/components/landscape/topics/UserInfo'
import {Events} from '@/lib/definitions'
import EventHub from '@/lib/eventHub'
import Popper from 'popper.js'

export default {
  name: 'TheFilterList',
  components: {UserInfo},
  data() {
    return {
      show: false,
      list: [],
      popper: null,
      type: '',
      keyNavigationIndex: 0
    }
  },
  mounted() {
    EventHub.on(Events.OPEN_FILTER_LIST, this.open)
    EventHub.on(Events.UPDATE_FILTER_LIST, this.update)
    EventHub.on(Events.CLOSE_FILTER_LIST, this.close)
    EventHub.on(Events.DO_SELECT_FILTER_LIST, () => {
      if (this.list.length > 0) {
        this.selectOne(this.list[this.keyNavigationIndex])
      }
    })
    EventHub.on(Events.PREV_SELECT_FILTER_LIST, () => {
      this.keyNavigationIndex =
        (this.keyNavigationIndex + this.list.length - 1) % this.list.length
    })
    EventHub.on(Events.NEXT_SELECT_FILTER_LIST, () => {
      this.keyNavigationIndex = (this.keyNavigationIndex + 1) % this.list.length
    })
  },

  methods: {
    open({node, list, type}) {
      this.update({list})
      this.type = type
      this.show = true
      this.keyNavigationIndex = 0
      const el = this.$refs.TheList
      if (!this.popper) {
        this.popper = new Popper(node, el, {
          placement: 'bottom-start',
          modifiers: {
            offset: {offset: '0, 5'}
          }
        })
      }
    },
    selectOne(item) {
      EventHub.emit(Events.SELECT_FILTER_LIST, item)
    },
    update({list}) {
      this.list = list
      this.keyNavigationIndex = 0
      if (this.popper) this.popper.scheduleUpdate()
    },
    close() {
      this.list = []
      this.keyNavigationIndex = 0
      this.show = false
      if (this.popper) {
        this.popper.destroy()
        this.popper = null
      }
    }
  }
}
</script>
